import React from 'react'

import clsx from 'clsx'

import classes from './BorderGradientContainer.module.scss'

const BorderGradientContainer = ({ children, className = '' }) => {
  return (
    <div className={clsx(classes.root, className)}>
      <div className={classes.container}>{children}</div>
    </div>
  )
}

export default BorderGradientContainer
